import React from "react";

export default function CommentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Group_21752"
      data-name="Group 21752"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        id="Path_16065"
        data-name="Path 16065"
        d="M0,0H32V32H0Z"
        fill="none"
      />
      <path
        id="Path_16066"
        data-name="Path 16066"
        d="M9.055,27.1,2,28.667l1.568-7.055A13.326,13.326,0,1,1,9.055,27.1Zm.387-2.817.871.467A10.664,10.664,0,1,0,5.92,20.355l.465.871-.873,3.929,3.929-.873Z"
        transform="translate(0.667 0.667)"
        fill="#fff"
      />
    </svg>
  );
}
